<script setup>
import headerLayout from '@/components/header.vue'
import footerLayout from '@/components/footer.vue'
import {getCurrentInstance, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import PdfLoading from "@/components/loading/PdfLoading.vue";
import {setUserInfo} from "./utils/auth.js";

const route = useRoute();
const darkRouter = ref(['/DMdoload/detail', '/login','/register','/terms/contract','/terms','/checkDetails'])

// 獲取個人信息
const {proxy} = getCurrentInstance()
function getAllUserInfo(){
  proxy.$get('/api/member/profile').then(res => {
    res.data.password = ''
    setUserInfo(JSON.stringify(res.data))
  })
}

onMounted(() => {
  if(!darkRouter.value.includes(window.location.pathname)){
    getAllUserInfo()
  }
})
</script>

<template>
  <div class="layout-wrapper">
  <header-layout v-if="!route.meta.hideLayout && !darkRouter.includes(route.path)"></header-layout>
  <div class="page-container">
  <router-view v-slot="{ Component }">
    <transition name="slide-fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
  </div>
  <footer-layout v-if="!route.meta.hideLayout"></footer-layout>
  <PdfLoading/>
  </div>
</template>

<style scoped>
.loader {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.5);
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
  position: absolute;
  width: 100%;
}

.slide-fade-enter-from {
  transform: translateX(100%);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.page-container{
  min-height: 80vh;
}
</style>
